import React from 'react';

class NavBarBrandLogo extends React.Component {
  render() {
    const { logo } = this.props;
    return (
      <div className="rd-navbar-brand">
        <a href="/">
          <img src={logo} width={129} height={129} />
        </a>
      </div>
    );
  }
}

export default NavBarBrandLogo;
